var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.33268C2.5 5.89065 2.67559 5.46673 2.98816 5.15417C3.30072 4.84161 3.72464 4.66602 4.16667 4.66602H15.8333C16.2754 4.66602 16.6993 4.84161 17.0118 5.15417C17.3244 5.46673 17.5 5.89065 17.5 6.33268V14.666C17.5 15.108 17.3244 15.532 17.0118 15.8445C16.6993 16.1571 16.2754 16.3327 15.8333 16.3327H4.16667C3.72464 16.3327 3.30072 16.1571 2.98816 15.8445C2.67559 15.532 2.5 15.108 2.5 14.666V6.33268Z",
    stroke: "#58486C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.33398L10 11.334L17.5 6.33398",
    stroke: "#58486C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.442992372f4c0ca1f096777e99659865.svg";
export { ForwardRef as ReactComponent };